module.exports = __webpack_public_path__ + "img/6.6d940660.png";